import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";

export const StatusHeader = ({ column }: HeaderContext<any, unknown>) => {
  return (
    <DataTableColumnHeader
      column={column}
      title="Status"
      style={{ padding: "5px" }}
    />
  );
};
